import { Card, CardContent, CardHeader } from "@/components/ui/card";
// import { BackgroundBoxes } from "@/components/ui/background-boxes";
import { BackgroundGradient } from "@/components/ui/background-gradient";
import { Button } from "@/components/ui/button";
import { useUser } from "@/hooks/useUser";
import { LuLoader, LuMoveRight } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
// import SnbpSvg from "@/assets/illustrations/snbp.svg";
// import SnbtSvg from "@/assets/illustrations/snbt.svg";
// import SmbjmSvg from "@/assets/illustrations/smbjm.svg";
import LogoSNBP from "@/assets/logos/snbp.png";
import LogoSNBT from "@/assets/logos/snbt.png";
// import {
//   GlowingStarsBackgroundCard,
//   GlowingStarsDescription,
//   GlowingStarsTitle,
// } from "@/components/ui/glowing-stars";
import Combobox from "@/components/Combobox";
import FormHeader from "@/components/FormHeader";
import InputError from "@/components/InputError";
import Modal from "@/components/Modal";
import SegmentedInput from "@/components/SegmentedInput";
import SkeletonCard from "@/components/SkeletonCard";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { MultiSelect } from "@/components/ui/multi-select";
import { web } from "@/config/System";
import { useCountdown } from "@/hooks/useCountdown";
import { useDebounce } from "@/hooks/useDebounce";
import useSessionStorage from "@/hooks/useSessionStorage";
import api from "@/lib/axios";
import { formatDateIndonesia } from "@/lib/utils";
import {
  getDataSekolahAsal,
  getDataSiswa,
  getListJurusanSekolah,
  getListKomponenDashboardSiswaRpl,
  getListMapelKumer,
  getListPerguruanTinggi,
  getListPerguruanTinggiProdi,
  getListSekolah,
} from "@/services/getData";
import {
  DataMapelPeminatan,
  DataSiswa,
  JenjangPendidikan,
  JurusanSekolah,
  MapelPeminatanKumer,
  Option,
  PerguruanTinggi,
  PerguruanTinggiProdi,
  Periode,
  Sekolah,
  SysProgramStudi,
} from "@/types";
import { AxiosError } from "axios";
import { ExternalLink, Loader2 } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { flushSync } from "react-dom";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { FaFaceFrown } from "react-icons/fa6";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { IoWarning } from "react-icons/io5";
import { MdWarning } from "react-icons/md";
import { RiGraduationCapFill } from "react-icons/ri";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

type InputState = {
  id_sys_periode: string;
  nama_lengkap: string;
  nisn: string;
  id_ref_sekolah: string;
  id_ref_jurusan_sekolah: string;
  is_kurikulum_merdeka: boolean | null | number;
  nomor_utbk?: string;
  uk_id?: string;
  asal_pt?: string;
  asal_prodi?: string;
  nim?: string;
  tahun_ijazah?: string;
  list_id_ref_mapel_peminatan_kurikulum_merdeka?: string[];
  tanggal_lahir?: string;
  jenjang_pendidikan_terakhir_daftar_rpl?: "sma" | "diploma" | null;
};

const listContentJalur = [
  {
    nama: "SNBP",
    description:
      "Penjaringan siswa secara nasional berdasarkan prestasi dengan nilai rapor dan prestasi akademik/non akademik lainnya.",
    icon: LogoSNBP,
  },
  {
    nama: "SNBT",
    description:
      "Penjaringan siswa secara nasional berdasarkan hasil tes UTBK, yang berfokus pada kemampuan penalaran dan pemecahan masalah.",
    icon: LogoSNBT,
  },
  {
    nama: "SMBJM-SKOR-UTBK",
    description:
      "Seleksi Mandiri Berbasis Jalur Mandiri dengan Skor UTBK, memungkinkan calon mahasiswa untuk mendaftar menggunakan nilai Ujian Tulis Berbasis Komputer (UTBK) sebagai indikator kelulusan.",
    icon: web.logo,
  },
  {
    nama: "SMBJM-CBT",
    description:
      "Seleksi Mandiri Berbasis Jalur Mandiri menggunakan metode Computer Based Test (CBT), memberikan kesempatan kepada calon mahasiswa untuk mengikuti ujian secara langsung di lokasi yang ditentukan.",
    icon: web.logo,
  },
  {
    nama: "SMBJM-NILAI RAPORT",
    description:
      "Jalur mandiri yang dikhususkan bagi calon mahasiswa dengan prestasi akademik atau non-akademik di berbagai bidang. Pastikan berkas pendukung prestasi Anda lengkap.",
    icon: web.logo,
  },
  {
    nama: "SMBJM-TALENT SCOUTING",
    description:
      "Jalur mandiri yang ditujukan bagi calon mahasiswa dengan bakat atau keterampilan khusus di bidang akademik maupun non-akademik. Seleksi didasarkan pada pencapaian dan potensi yang dimiliki.",
    icon: web.logo,
  },
  {
    nama: "Alih Kredit",
    description:
      "Jalur penerimaan mahasiswa untuk program alih kredit bagi mereka yang telah menyelesaikan sebagian pendidikan di institusi lain dan ingin melanjutkan di sini.",
    icon: web.logo,
  },
  {
    nama: "Program Pascasarjana",
    description:
      "Jalur penerimaan untuk program magister (S2) dan doktoral (S3), dirancang untuk calon mahasiswa yang ingin melanjutkan pendidikan ke jenjang lebih tinggi.",
    icon: web.logo,
  },
  {
    nama: "Profesi",
    description:
      "Jalur penerimaan untuk program pendidikan profesi, dirancang bagi calon mahasiswa yang ingin memperoleh keahlian dan sertifikasi di bidang tertentu",
    icon: web.logo,
  },
  {
    nama: "International Admission Track",
    description:
      "Jalur penerimaan khusus untuk program internasional yang dirancang bagi mahasiswa yang ingin mengejar pendidikan dengan standar global.",
    icon: web.logo,
  },
  {
    nama: "Afirmasi",
    description:
      "Jalur khusus yang memberikan kesempatan kepada calon mahasiswa dari daerah 3T (Tertinggal, Terdepan, dan Terluar) atau kategori afirmasi lainnya untuk melanjutkan pendidikan tinggi.",
    icon: web.logo,
  },
];

function renderWarningMessage(message: string) {
  return message.split(/(\*b.*?\*b)/).map((part, index) => {
    if (part.startsWith("*b") && part.endsWith("*b")) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return part;
  });
}

const cekAksesPendaftaran = async ({
  id_sys_periode,
}: {
  id_sys_periode: string;
}) => {
  const response = await api.post("/siswa/cek-akses-pendaftaran", {
    id_sys_periode,
  });
  return response.data;
};

const storeDataPendaftaran = async (newData: InputState) => {
  const response = await api.post(
    "/siswa/penerimaan/smbjm/pendaftaran/store",
    newData,
  );
  return response.data;
};

const jenjangMap: Record<string, string> = {
  D3: "Diploma",
  D4: "Applied Bachelor’s Degree (D4)",
  S1: "Bachelor's Degree",
  S2: "Master's Degree",
  "S2 Terapan": "Applied Master's Degree",
  S3: "Doctoral Degree",
};

export default function DashboardSiswaRplPage() {
  const { t } = useTranslation();

  const { user } = useUser();
  const navigate = useNavigate();
  const [_, setSessionPeriode] = useSessionStorage("sessionPeriode", {
    id_sys_periode: "",
  });

  const searchQueryRef = useRef<HTMLInputElement | null>(null);

  const [showWarning, setShowWarning] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");
  const [showPopupJalurMandiri, setShowPopupJalurMandiri] = useState(false);
  const [showConfirmDaftar, setShowConfirmDaftar] = useState(false);
  const [selectedPeriode, setSelectedPeriode] = useState<Periode | null>(null);
  const [form, setForm] = useState<InputState>({
    id_sys_periode: selectedPeriode?.id_sys_periode || "",
    nama_lengkap: "",
    nisn: "",
    id_ref_sekolah: "",
    id_ref_jurusan_sekolah: "",
    is_kurikulum_merdeka: null,
    nomor_utbk: "",
    uk_id: "",
    asal_pt: "",
    asal_prodi: "",
    nim: "",
    tahun_ijazah: "",
    list_id_ref_mapel_peminatan_kurikulum_merdeka: [],
    tanggal_lahir: "",
    jenjang_pendidikan_terakhir_daftar_rpl: null,
  });
  const [selectedJenjang, setSelectedJenjang] = useState("");
  const [openListJenjang, setOpenListJenjang] = useState(false);
  const [openListProdi, setOpenListProdi] = useState(false);
  const [openListJurusan, setOpenListJurusan] = useState(false);
  const [openListSekolah, setOpenListSekolah] = useState(false);
  const [searchQuerySekolah, setSearchQuerySekolah] = useState("");
  const [selectedSekolah, setSelectedSekolah] = useState<
    (Option & { bentuk_pendidikan: string }) | null
  >(null);
  const [openAsalUniversitas, setOpenAsalUniversitas] = useState(false);
  const [openAsalProdi, setOpenAsalProdi] = useState(false);
  const [searchQueryUniversitas, setSearchQueryUniversitas] = useState("");
  const [selectedAsalUniversitas, setSelectedAsalUniversitas] = useState<
    (Option & { nama_singkat: string }) | null
  >(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedMapels, setSelectedMapels] = useState<string[]>([]);
  const [isConfirm, setIsConfirm] = useState(false);

  const [linkTelegram, setLinkTelegram] = useState("");
  const [waktuMulaiIsiUkt, setWaktuMulaiIsiUkt] = useState<string | null>(null);
  const { countdown, isReady } = useCountdown(waktuMulaiIsiUkt);

  const debouncedSearchQuery = useDebounce(searchQuery, 1000);
  const debouncedQueryUniversitas = useDebounce(searchQueryUniversitas, 1000);
  const debouncedSearchQuerySekolah = useDebounce(searchQuerySekolah, 1000);

  const isJalurInternasional =
    selectedPeriode &&
    selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug == "internasional";

  const { data, isPending } = useQuery({
    queryKey: ["listKomponenDashboardSiswa", debouncedSearchQuery],
    queryFn: () => getListKomponenDashboardSiswaRpl(debouncedSearchQuery),
  });

  const { data: dataSiswa } = useQuery<DataSiswa>({
    queryKey: ["dataSiswa", user?.id],
    queryFn: () => getDataSiswa(),
    enabled: !!user?.id,
  });

  const { data: optionsPt, isPending: isPendingOptionsPt } = useQuery({
    queryKey: ["listPerguruanTinggi", debouncedQueryUniversitas, form.asal_pt],
    queryFn: () => getListPerguruanTinggi("1", "1", `${web.univAcronym}`),
    select: (data) => {
      if (!data) return [];
      return data?.map((item: PerguruanTinggi) => ({
        label: item.nama_perguruan_tinggi,
        value: `${item.id_feeder}`,
        nama_singkat: item.nama_singkat,
      }));
    },
  });

  const { data: dataAsalProdi } = useQuery({
    queryKey: ["listAsalProdi", form.asal_pt],
    queryFn: () => getListPerguruanTinggiProdi("1", "1000", form.asal_pt || ""),
    select: (data) => {
      return data?.map((item: PerguruanTinggiProdi) => ({
        label: `${item.nama_program_studi} (${item.nama_jenjang_pendidikan})`,
        value: `${item.id_feeder}`,
        nama_jenjang_pendidikan: item.nama_jenjang_pendidikan,
      }));
    },
    enabled: !!form.asal_pt,
  });

  const optionsAsalProdi = dataAsalProdi
    ? dataAsalProdi?.filter((item: Option) => {
        return (
          item.nama_jenjang_pendidikan === "S1" ||
          item.nama_jenjang_pendidikan === "D4"
        );
      })
    : [];

  const { data: dataSekolah, isPending: isPendingSekolah } = useQuery({
    queryKey: ["listSekolah", debouncedSearchQuerySekolah, form.id_ref_sekolah],
    queryFn: () =>
      getListSekolah(
        "1",
        "10",
        debouncedSearchQuerySekolah
          ? debouncedSearchQuerySekolah
          : form.id_ref_sekolah,
      ),
    select: (data) =>
      data?.data?.map((sekolah: Sekolah) => ({
        label: `${sekolah.nama_sekolah} (${sekolah.npsn_sekolah})`,
        value: `${sekolah.id_ref_sekolah}`,
        bentuk_pendidikan: sekolah.bentuk_pendidikan,
      })),
  });

  const { data: listJurusan, isPending: isPendingListJurusan } = useQuery({
    queryKey: ["listJurusan", selectedSekolah],
    queryFn: () => getListJurusanSekolah(selectedSekolah?.bentuk_pendidikan),
    select: (data) =>
      data?.map((jurusan: JurusanSekolah) => ({
        label: jurusan.nama_jurusan_sekolah,
        value: `${jurusan.id_ref_jurusan_sekolah}`,
      })),
    enabled: !!selectedSekolah,
  });

  const filteredListJurusan = listJurusan?.filter((option: Option) => {
    return !option?.label?.startsWith("Umum");
  });

  // const { data: listJurusanAll } = useQuery({
  //   queryKey: ["listJurusan"],
  //   queryFn: () => getListJurusanSekolah(),
  //   select: (data) =>
  //     data?.map((jurusan: JurusanSekolah) => ({
  //       label: jurusan.nama_jurusan_sekolah,
  //       value: `${jurusan.id_ref_jurusan_sekolah}`,
  //     })),
  // });

  const { data: dataSekolahAsal } = useQuery<DataSiswa>({
    queryKey: ["dataSekolahAsal", user?.id],
    queryFn: () => getDataSekolahAsal(),
    enabled: !!user?.id,
  });

  const { data: listMapelPeminatan } = useQuery({
    queryKey: ["listMapelPeminatan"],
    queryFn: () => getListMapelKumer(),
    select: (data) =>
      data?.map((mapel: MapelPeminatanKumer) => ({
        label: `${mapel.nama_mapel}`,
        value: `${mapel?.idref_mapel_peminatan_kurikulum_merdeka}`,
      })),
  });

  const optionsProdi =
    selectedPeriode && selectedPeriode?.sys_prodi
      ? selectedPeriode?.sys_prodi.map((item: SysProgramStudi) => {
          return {
            label: isJalurInternasional
              ? `${item?.unitkerja?.name}`
              : `${item.unitkerja?.nama}`,
            value: `${item.uk_id}`,
            jenjang: `${item?.unitkerja?.uk_program}`,
          } as Option;
        })
      : [];

  const queryClient = useQueryClient();
  const {
    mutate,
    isPending: isPendingStorePendaftaran,
    error,
  } = useMutation({
    mutationFn: storeDataPendaftaran,
    onSuccess: (data) => {
      flushSync(() => {
        setSessionPeriode({ id_sys_periode: data?.data?.id_sys_periode });
      });

      queryClient.invalidateQueries({ queryKey: ["dataStep"] });
      queryClient.invalidateQueries({ queryKey: ["dataPendaftaran"] });
      queryClient.invalidateQueries({ queryKey: ["dataSiswa"] });
      navigate(data?.data?.redirect_url);
      toast.success(data?.message || "Success.");
    },
    onError: (
      error: AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
      }>,
    ) => {
      setShowConfirmDaftar(false);

      const err = error as AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
      }>;
      const errorMessage =
        err.response?.data?.message || "An unexpected error occurred.";
      toast.error(errorMessage);
    },
  });
  const {
    mutate: mutateCekAksesPendaftaran,
    isPending: isPendingCekAksesPendaftaran,
  } = useMutation({
    mutationFn: cekAksesPendaftaran,
    onSuccess: (data) => {
      if (!data?.data?.dataPendaftaran) {
        setShowPopupJalurMandiri(true);
        setForm((prev) => ({
          ...prev,
          id_sys_periode: data?.data?.id_sys_periode,
        }));
      }

      flushSync(() => {
        setSessionPeriode({ id_sys_periode: data?.data?.id_sys_periode });
      });
      navigate(data?.data?.redirect_url);
    },
    onError: (
      error: AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
        data?: {
          waktu_mulai_isi_ukt?: string;
          id_sys_periode?: string;
          link_telegram?: string;
        };
      }>,
    ) => {
      const waktuMulaiIsiUkt =
        error?.response?.data?.data &&
        error?.response?.data?.data?.waktu_mulai_isi_ukt;
      if (waktuMulaiIsiUkt) {
        setWaktuMulaiIsiUkt(waktuMulaiIsiUkt);
        setSessionPeriode({
          id_sys_periode: error?.response?.data?.data?.id_sys_periode || "",
        });
        setForm((prev) => ({
          ...prev,
          id_sys_periode: error?.response?.data?.data?.id_sys_periode || "",
        }));
        setLinkTelegram(error?.response?.data?.data?.link_telegram || "");
      }

      const err = error as AxiosError<{
        message?: string;
        errors?: Record<string, string[]>;
      }>;
      const errorMessage =
        err.response?.data?.message || "An unexpected error occurred.";

      setShowWarning(true);
      setWarningMessage(errorMessage);
      toast.error(errorMessage);
    },
  });

  const handleSubmitPendaftaran = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    let data = { ...form };

    data = {
      ...form,
      list_id_ref_mapel_peminatan_kurikulum_merdeka: selectedMapels,
    };

    mutate(data);
  };

  useEffect(() => {
    if (!user && !dataSiswa) return;
    setForm((prev) => ({
      ...prev,
      nama_lengkap: user?.nama_lengkap || "",
      nisn: dataSiswa?.nisn || "",
      id_ref_sekolah: dataSiswa?.id_ref_sekolah || "",
    }));
  }, [user, dataSiswa]);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "/") {
        event.preventDefault();
        searchQueryRef.current?.focus();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    if (dataSekolahAsal) {
      setForm((prev) => ({
        ...prev,
        id_ref_sekolah: prev.id_ref_sekolah
          ? prev.id_ref_sekolah
          : dataSekolahAsal.id_ref_sekolah || "",
        is_kurikulum_merdeka:
          prev.is_kurikulum_merdeka !== null
            ? prev.is_kurikulum_merdeka
            : dataSekolahAsal.is_kurikulum_merdeka === 0
              ? false
              : dataSekolahAsal.is_kurikulum_merdeka === 1
                ? true
                : null,
        id_ref_jurusan_sekolah: prev.id_ref_jurusan_sekolah
          ? prev.id_ref_jurusan_sekolah
          : dataSekolahAsal?.id_ref_jurusan_sekolah || "",
      }));
      const listIdMapelPeminatan = dataSekolahAsal?.data_mapel_peminatan?.map(
        (dataMapelPeminatan: DataMapelPeminatan) => {
          return `${dataMapelPeminatan.idref_mapel_peminatan_kurikulum_merdeka}`;
        },
      );
      setSelectedMapels(listIdMapelPeminatan as string[]);
    }
  }, [dataSekolahAsal]);

  useEffect(() => {
    const currentSekolah = dataSekolah?.find((option: Option) => {
      return option.value == form.id_ref_sekolah;
    });
    setSelectedSekolah(currentSekolah);
  }, [dataSekolah]);

  const isSMA =
    selectedSekolah &&
    (selectedSekolah?.bentuk_pendidikan?.startsWith("SMA") ||
      selectedSekolah?.bentuk_pendidikan?.startsWith("MA"));
  const isSMK =
    selectedSekolah && selectedSekolah?.bentuk_pendidikan?.startsWith("SMK");
  const isPKBM =
    selectedSekolah && selectedSekolah?.bentuk_pendidikan?.startsWith("PKBM");

  const currentMapels =
    selectedMapels?.length > 0
      ? (listMapelPeminatan?.filter((option: Option) =>
          selectedMapels.includes(option.value),
        ) ?? [])
      : [];
  const currentJurusan = listJurusan?.find((option: Option) => {
    return option.value == form.id_ref_jurusan_sekolah;
  });

  const { i18n } = useTranslation();

  const optionsJenjang =
    i18n.language == "en"
      ? [
          { label: "Applied Bachelor’s Degree (D4)", value: "D4" },
          { label: "Bachelor's Degree (S1)", value: "S1" },
          { label: "Master's Degree (S2)", value: "S2" },
          { label: "Doctoral Degree (S3)", value: "S3" },
        ]
      : [
          { label: "Magister (S2)", value: "S2" },
          { label: "Doktor (S3)", value: "S3" },
        ];

  const filteredOptionsJenjang = selectedPeriode
    ? optionsJenjang.filter((option: Option) => {
        return selectedPeriode.jenjang_buka?.some(
          (jenjang: JenjangPendidikan) =>
            jenjang.nama_jenjang_pendidikan === option.value,
        );
      })
    : [];

  const filteredOptionsProdi = selectedJenjang
    ? (optionsProdi?.filter((option: Option) => {
        return (
          typeof (option as any).jenjang === "string" &&
          (option as any).jenjang.includes(selectedJenjang)
        );
      }) ?? [])
    : (optionsProdi ?? []);

  return (
    <main>
      <section className="my-10 mb-14">
        {/* <div className="h-[15rem] relative w-full overflow-hidden bg-white dark:bg-dark dark:text-white flex flex-col items-center justify-center rounded-lg">
          <div className="absolute inset-0 w-full h-full bg-white dark:bg-dark z-20 [mask-image:radial-gradient(transparent,white)] pointer-events-none" />
          <BackgroundBoxes />
          <div>
            <div className="absolute inset-0 w-full h-full bg-white dark:bg-dark z-20 [mask-image:radial-gradient(ellipse_at_top,transparent_20%,black)] pointer-events-none" /> */}
        <div className="relative z-20 pointer-events-none text-center">
          <h1 className="mb-3 lg:text-4xl text-2xl font-bold text-center">
            {t("siswa.layout.dashboard.title")}, {user?.nama_lengkap}
          </h1>
          <p className="text-center lg:text-xl text-base text-muted-foreground lg:max-w-[70%] mx-auto">
            {t("siswa.layout.dashboard.description")}
          </p>
        </div>
        <div className="mt-10">
          <div className="relative">
            <Input
              ref={searchQueryRef}
              placeholder={`${t("siswa.layout.dashboard.search")}`}
              className="px-7 py-7"
              value={searchQuery}
              onChange={(event) => setSearchQuery(event.target.value)}
            />
            <div className="absolute right-2 top-1/2 -translate-y-1/2">
              <button className="py-2 px-2 w-12 h-12 bg-black/80 text-white font-semibold text-xs rounded-full">
                /
              </button>
            </div>
          </div>
        </div>
        {/* </div>
        </div> */}
      </section>
      {debouncedSearchQuery && (
        <section className="mb-14">
          <div className="mb-5 text-3xl font-bold text-center">
            {t("siswa.layout.dashboard.search.result.label")} :
            <span className="text-primary"> "{debouncedSearchQuery}"</span>
          </div>
          <div className="w-fit mx-auto">
            <Button variant={"outline"} onClick={() => setSearchQuery("")}>
              {t("siswa.layout.dashboard.search.result.delete")}
            </Button>
          </div>
        </section>
      )}
      {isPending ? (
        <section className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5">
          {Array(3)
            .fill(null)
            .map((_, index) => {
              return <SkeletonCard key={index} />;
            })}
        </section>
      ) : (
        <>
          {data && Object.keys(data?.listPeriode)?.length > 0 ? (
            <section className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5">
              {Object.keys(data?.listPeriode).map((namaJalur) => {
                const contentJalur = listContentJalur.find((content) => {
                  return (
                    content.nama.toLowerCase() === namaJalur.toLowerCase() ||
                    namaJalur
                      .split(" ")[1]
                      ?.toLowerCase()
                      .startsWith(content.nama.toLowerCase())
                  );
                });

                return (
                  <div key={namaJalur}>
                    <div className="flex gap-3">
                      {namaJalur?.startsWith("SNBP") ||
                      namaJalur?.startsWith("SNBT") ? (
                        <img src={contentJalur?.icon} alt={namaJalur} />
                      ) : (
                        ""
                      )}
                      <h1 className="mb-3 font-bold text-xl flex gap-5 text-primary">
                        {namaJalur}
                      </h1>
                    </div>
                    <section className="flex flex-col gap-y-3">
                      {data?.listPeriode[namaJalur].map((periode: Periode) => {
                        const isPeriodeInternasional =
                          periode?.jalur_jenis?.nama_jalur_jenis_slug ==
                          "internasional";

                        const isJalurSbmjm =
                          periode.jalur_jenis?.nama_jalur_jenis_slug == "cbt" ||
                          periode.jalur_jenis?.nama_jalur_jenis_slug ==
                            "talentscouting" ||
                          periode.jalur_jenis?.nama_jalur_jenis_slug ==
                            "prestasi";

                        if (
                          periode.is_jalur_siswa_lulus &&
                          isJalurSbmjm &&
                          periode.waktu_pengumuman_kelulusan &&
                          new Date() <
                            new Date(periode.waktu_pengumuman_kelulusan)
                        ) {
                          return (
                            <div
                              key={periode.id_sys_periode}
                              onClick={() => {
                                setForm((prev) => ({
                                  ...prev,
                                  id_sys_periode: periode?.id_sys_periode,
                                }));
                                setSelectedPeriode(periode);
                                mutateCekAksesPendaftaran({
                                  id_sys_periode: periode.id_sys_periode,
                                });
                              }}
                            >
                              <Card className="group cursor-pointer hover:border-primary">
                                <CardHeader>
                                  <h1 className="font-bold italic">
                                    {isPeriodeInternasional
                                      ? periode?.nama_jalur_jenis
                                      : namaJalur}
                                    {data?.listPeriode[namaJalur]?.length > 1 &&
                                    !isPeriodeInternasional ? (
                                      <span>
                                        {" "}
                                        Gelombang {periode.gelombang}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </h1>
                                  <div className="font-bold text-xl flex items-center gap-3">
                                    <RiGraduationCapFill
                                      className="text-primary w-10"
                                      size={20}
                                    />
                                    {isPeriodeInternasional ? (
                                      <div className="text-base">
                                        Programs Offered:{" "}
                                        <span className="text-purple-500">
                                          {periode?.jenjang_buka
                                            ?.map((jenjang) => {
                                              const key =
                                                jenjang?.nama_jenjang_pendidikan;
                                              return key && jenjangMap[key]
                                                ? jenjangMap[key]
                                                : (key ?? "-");
                                            })
                                            ?.join(", ")}
                                        </span>
                                      </div>
                                    ) : (
                                      <div className="text-base">
                                        Program{" "}
                                        <span className="text-purple-500">
                                          {periode?.jenjang_buka
                                            ?.map(
                                              (jenjang) =>
                                                jenjang?.nama_jenjang_pendidikan,
                                            )
                                            ?.join(", ")}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </CardHeader>
                                <CardContent>
                                  <p>
                                    {periode?.keterangan
                                      ? periode.keterangan
                                      : contentJalur?.description}
                                  </p>
                                  <div className="flex justify-end">
                                    {isPendingCekAksesPendaftaran &&
                                    selectedPeriode?.id_sys_periode ==
                                      periode.id_sys_periode ? (
                                      <div className="flex items-center gap-3">
                                        <LuLoader className="animate-spin" />
                                        <span>Checking...</span>
                                      </div>
                                    ) : (
                                      <Button
                                        size={"icon"}
                                        variant={"secondary"}
                                      >
                                        <LuMoveRight
                                          size={15}
                                          className="group-hover:translate-x-1 duration-300"
                                        />
                                      </Button>
                                    )}
                                  </div>
                                </CardContent>
                              </Card>
                            </div>
                          );
                        } else if (periode.is_jalur_siswa_lulus) {
                          return (
                            <div
                              key={periode.id_sys_periode}
                              onClick={() => {
                                setForm((prev) => ({
                                  ...prev,
                                  id_sys_periode: periode?.id_sys_periode,
                                }));
                                setSelectedPeriode(periode);
                                mutateCekAksesPendaftaran({
                                  id_sys_periode: periode.id_sys_periode,
                                });
                              }}
                            >
                              <BackgroundGradient>
                                <Card className="bg-white group cursor-pointer">
                                  <CardHeader>
                                    <div>
                                      <Badge>Lulus</Badge>
                                      <h1 className="font-bold italic">
                                        {isPeriodeInternasional
                                          ? periode?.nama_jalur_jenis
                                          : namaJalur}
                                        {data?.listPeriode[namaJalur]?.length >
                                          1 && !isPeriodeInternasional ? (
                                          <span>
                                            {" "}
                                            Gelombang {periode.gelombang}
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </h1>
                                      <div className="font-bold text-xl flex items-center gap-3">
                                        <RiGraduationCapFill className="text-primary w-20" />
                                        {isPeriodeInternasional ? (
                                          <div className="text-base">
                                            Programs Offered:{" "}
                                            <span className="text-purple-500">
                                              {periode?.jenjang_buka
                                                ?.map((jenjang) => {
                                                  const key =
                                                    jenjang?.nama_jenjang_pendidikan;
                                                  return key && jenjangMap[key]
                                                    ? jenjangMap[key]
                                                    : (key ?? "-");
                                                })
                                                ?.join(", ")}
                                            </span>
                                          </div>
                                        ) : (
                                          <div className="text-base">
                                            Program{" "}
                                            <span className="text-purple-500">
                                              {periode?.jenjang_buka
                                                ?.map(
                                                  (jenjang) =>
                                                    jenjang?.nama_jenjang_pendidikan,
                                                )
                                                ?.join(", ")}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </CardHeader>
                                  <CardContent>
                                    <p>
                                      {periode?.keterangan
                                        ? periode.keterangan
                                        : contentJalur?.description}
                                    </p>
                                    <div className="flex justify-end">
                                      {isPendingCekAksesPendaftaran &&
                                      selectedPeriode?.id_sys_periode ==
                                        periode.id_sys_periode ? (
                                        <div className="flex items-center gap-3">
                                          <LuLoader className="animate-spin" />
                                          <span>Checking...</span>
                                        </div>
                                      ) : (
                                        <Button
                                          size={"icon"}
                                          variant={"secondary"}
                                        >
                                          <LuMoveRight
                                            size={15}
                                            className="group-hover:translate-x-1 duration-300"
                                          />
                                        </Button>
                                      )}
                                    </div>
                                  </CardContent>
                                </Card>
                              </BackgroundGradient>
                            </div>
                          );
                        }

                        return (
                          <div
                            key={periode.id_sys_periode}
                            onClick={() => {
                              setForm((prev) => ({
                                ...prev,
                                id_sys_periode: periode?.id_sys_periode,
                              }));
                              setSelectedPeriode(periode);
                              mutateCekAksesPendaftaran({
                                id_sys_periode: periode.id_sys_periode,
                              });
                            }}
                          >
                            <Card className="group cursor-pointer hover:border-primary">
                              <CardHeader>
                                <h1 className="font-bold italic">
                                  {isPeriodeInternasional
                                    ? periode?.nama_jalur_jenis
                                    : namaJalur}
                                  {data?.listPeriode[namaJalur]?.length > 1 &&
                                  !isPeriodeInternasional ? (
                                    <span> Gelombang {periode.gelombang}</span>
                                  ) : (
                                    ""
                                  )}
                                </h1>
                                <div className="font-bold text-xl flex items-center gap-3">
                                  <RiGraduationCapFill
                                    className="text-primary w-10"
                                    size={20}
                                  />
                                  {isPeriodeInternasional ? (
                                    <div className="text-base">
                                      Programs Offered:{" "}
                                      <span className="text-purple-500">
                                        {periode?.jenjang_buka
                                          ?.map((jenjang) => {
                                            const key =
                                              jenjang?.nama_jenjang_pendidikan;
                                            return key && jenjangMap[key]
                                              ? jenjangMap[key]
                                              : (key ?? "-");
                                          })
                                          ?.join(", ")}
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="text-base">
                                      Program{" "}
                                      <span className="text-purple-500">
                                        {periode?.jenjang_buka
                                          ?.map(
                                            (jenjang) =>
                                              jenjang?.nama_jenjang_pendidikan,
                                          )
                                          ?.join(", ")}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </CardHeader>
                              <CardContent>
                                <p>
                                  {periode?.keterangan
                                    ? periode.keterangan
                                    : contentJalur?.description}
                                </p>
                                <div className="flex justify-end">
                                  {isPendingCekAksesPendaftaran &&
                                  selectedPeriode?.id_sys_periode ==
                                    periode.id_sys_periode ? (
                                    <div className="flex items-center gap-3">
                                      <LuLoader className="animate-spin" />
                                      <span>Checking...</span>
                                    </div>
                                  ) : (
                                    <Button size={"icon"} variant={"secondary"}>
                                      <LuMoveRight
                                        size={15}
                                        className="group-hover:translate-x-1 duration-300"
                                      />
                                    </Button>
                                  )}
                                </div>
                              </CardContent>
                            </Card>
                          </div>
                        );
                      })}
                    </section>
                  </div>
                );
              })}
            </section>
          ) : (
            <div>
              <FaFaceFrown size={50} className="mx-auto mb-5" />
              <p className="text-center font-bold text-4xl">
                {t("siswa.layout.dashboard.search.result.notfound")}
              </p>
            </div>
          )}
        </>
      )}

      <Modal
        show={showWarning}
        onClose={() => setShowWarning(false)}
        className="w-[28rem]"
      >
        <IoWarning size={50} className="mx-auto" />
        <h1 className="mt-3 mb-5 text-xl font-semibold text-center">
          Perhatian!
        </h1>
        <div className="p-3 rounded-xl border border-yellow-500 bg-yellow-50">
          <div className="p-3">{renderWarningMessage(warningMessage)}</div>
        </div>
        {waktuMulaiIsiUkt && (
          <div className="mt-5 p-3">
            {linkTelegram && (
              <div className="mb-10">
                <p className="text-justify">
                  Silakan bergabung ke grup Telegram "Pendaftaran Kembali
                  Mahasiswa Baru Tahun 2025" melalui tautan berikut:
                </p>
                <p>
                  👉{" "}
                  <Link
                    to={linkTelegram}
                    target="_blank"
                    className="ml-3 text-primary underline"
                  >
                    Link Grup Telegram
                  </Link>
                </p>
                <p className="text-justify">
                  📌 Mohon untuk tidak membagikan tautan grup Telegram ini
                  kepada siapa pun. Grup ini hanya diperuntukkan bagi calon
                  mahasiswa {web.univAcronym} yang sudah lulus seleksi.
                  <span className="text-red-500">
                    {" "}
                    Wajib menggunakan nama dan foto asli pada telegram. Jika
                    tidak sesuai maka tidak akan diijinkan masuk grup
                  </span>
                </p>
              </div>
            )}
            <div className="flex items-center justify-center gap-3">
              <div className="p-3 bg-secondary rounded-xl">
                <h1 className="text-4xl font-bold">{countdown?.days}</h1>
              </div>
              <h1 className="text-4xl font-bold">:</h1>
              <div className="p-3 bg-secondary rounded-xl">
                <h1 className="text-4xl font-bold">{countdown?.hours}</h1>
              </div>
              <h1 className="text-4xl font-bold">:</h1>
              <div className="p-3 bg-secondary rounded-xl">
                <h1 className="text-4xl font-bold">{countdown?.minutes}</h1>
              </div>
              <h1 className="text-4xl font-bold">:</h1>
              <div className="p-3 bg-secondary rounded-xl">
                <h1 className="text-4xl font-bold">{countdown?.seconds}</h1>
              </div>
            </div>
            <div className="mt-5 flex justify-center">
              {isReady && (
                <Link to={"/daftar-kembali"}>
                  <Button variant={"default"} className="flex gap-3">
                    Daftarkembali <HiOutlineArrowNarrowRight />
                  </Button>
                </Link>
              )}
            </div>
          </div>
        )}
      </Modal>

      <Modal
        show={showPopupJalurMandiri}
        onClose={() => setShowPopupJalurMandiri(false)}
        className="lg:w-auto w-[95vw]"
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            setShowConfirmDaftar(true);
            setIsConfirm(false);
          }}
          className="flex flex-col gap-y-3"
        >
          <h1 className="mb-3 font-bold text-xl text-center">
            {t("siswa.layout.register.title")}{" "}
            <span className="text-primary">
              {selectedPeriode?.jalur_jenis?.nama_jalur_jenis}
            </span>
          </h1>
          <div>
            <Label required>
              {t("siswa.layout.register.label.nama-lengkap")}
            </Label>
            <Input
              required
              placeholder={`type ${t(
                "siswa.layout.register.label.nama-lengkap",
              )}...`}
              value={form.nama_lengkap}
              onChange={(event) =>
                setForm((prev) => ({
                  ...prev,
                  nama_lengkap: event.target.value,
                }))
              }
            />
            <p className="text-muted-foreground text-sm">
              {t("siswa.layout.register.label.nama-lengkap.description")}
            </p>
            <InputError
              text={error?.response?.data.errors?.nama_lengkap?.join(",")}
            />
          </div>
          {selectedPeriode?.jalur_jenis?.is_cek_pusat ? (
            <div>
              <Label>Nomor UTBK</Label>
              <Input
                placeholder="Nomor UTBK..."
                value={form.nomor_utbk}
                onChange={(event) =>
                  setForm((prev) => ({
                    ...prev,
                    nomor_utbk: event.target.value,
                  }))
                }
              />
              <InputError
                text={error?.response?.data.errors?.nomor_utbk?.join(",")}
              />
            </div>
          ) : (
            ""
          )}
          {selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
            "profesi",
          ) ? (
            <>
              <div>
                <Label required>
                  Asal Perguruan Tinggi/Universitas/Institusi
                </Label>
                <Combobox
                  serverSide
                  open={openAsalUniversitas}
                  setOpen={setOpenAsalUniversitas}
                  value={form.asal_pt || ""}
                  setValue={(newValue) => {
                    const selected = optionsPt?.find((option: Option) => {
                      return option?.value === newValue;
                    });
                    setSelectedAsalUniversitas(selected);
                    setForm((prev) => ({
                      ...prev,
                      asal_pt: newValue,
                    }));
                  }}
                  onChange={(event) =>
                    setSearchQueryUniversitas(event.target.value)
                  }
                  options={optionsPt}
                  placeholder="Pilih Asal Perguruan Tinggi"
                  isPending={isPendingOptionsPt}
                  searchQueryValue={searchQueryUniversitas || ""}
                />
              </div>

              {selectedAsalUniversitas &&
              selectedAsalUniversitas?.nama_singkat?.startsWith(
                `${web.univAcronym}`,
              ) ? (
                <div>
                  <Label required>NIM {web.univAcronym}</Label>
                  <Input
                    required
                    value={form.nim || ""}
                    placeholder="Ketik NIM..."
                    onChange={(event) =>
                      setForm((prev) => ({
                        ...prev,
                        nim: event.target.value,
                      }))
                    }
                  />
                  <InputError
                    text={error?.response?.data?.errors?.nim?.join(",")}
                  />
                </div>
              ) : (
                <div>
                  <Label required>Asal Program Studi</Label>
                  <Combobox
                    open={openAsalProdi}
                    setOpen={setOpenAsalProdi}
                    value={form.asal_prodi || ""}
                    setValue={(newValue) => {
                      setForm((prev) => ({
                        ...prev,
                        asal_prodi: newValue,
                      }));
                    }}
                    options={optionsAsalProdi}
                    placeholder="Pilih Asal Program Studi"
                    isPending={isPendingOptionsPt}
                  />
                  <InputError
                    text={error?.response?.data?.errors?.asal_prodi?.join(",")}
                  />
                </div>
              )}
            </>
          ) : selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
              "rpl",
            ) ? (
            <>
              <div>
                <Label>NISN</Label>
                <SegmentedInput
                  type="number"
                  length={10}
                  defaultValue={form.nisn}
                  onComplete={(value: string) => {
                    setForm((prev) => ({
                      ...prev,
                      nisn: value,
                    }));
                  }}
                />
                <InputError
                  text={error?.response?.data.errors?.nisn?.join(",")}
                />
                <div>
                  <p className="text-muted-foreground">
                    NISN bisa anda lihat melalui link berikut
                  </p>
                  <Link
                    to="https://nisn.data.kemendikdasmen.go.id"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline transition-colors"
                  >
                    Cek NISN disini
                    <ExternalLink className="w-3.5 h-3.5" />
                  </Link>
                </div>
              </div>
              <div>
                <Label required>
                  Apa jenjang pendidikan terakhir yang anda gunakan untuk
                  mendaftar RPL?
                </Label>
                <div className="mt-1 space-y-1">
                  <div className="flex space-x-3 items-center">
                    <Checkbox
                      required={!form.jenjang_pendidikan_terakhir_daftar_rpl}
                      checked={
                        form.jenjang_pendidikan_terakhir_daftar_rpl == "sma"
                      }
                      onCheckedChange={() =>
                        setForm((prev) => ({
                          ...prev,
                          jenjang_pendidikan_terakhir_daftar_rpl: "sma",
                        }))
                      }
                    />
                    <span>SMA/MA/SMK Sederajat</span>
                  </div>
                  <div className="flex space-x-3 items-center">
                    <Checkbox
                      required={!form.jenjang_pendidikan_terakhir_daftar_rpl}
                      checked={
                        form.jenjang_pendidikan_terakhir_daftar_rpl == "diploma"
                      }
                      onCheckedChange={() =>
                        setForm((prev) => ({
                          ...prev,
                          jenjang_pendidikan_terakhir_daftar_rpl: "diploma",
                        }))
                      }
                    />
                    <span>Diploma 3 (D3)</span>
                  </div>
                  <InputError
                    text={error?.response?.data.errors?.jenjang_pendidikan_terakhir_daftar_rpl?.join(
                      ",",
                    )}
                  />
                </div>
              </div>

              <div>
                <Label required>
                  {t("siswa.layout.register.label.tahun-kelulusan")}
                </Label>
                <Input
                  required
                  type="number"
                  maxLength={4}
                  placeholder={`type ${t(
                    "siswa.layout.register.label.tahun-kelulusan",
                  )}...`}
                  value={form.tahun_ijazah}
                  onChange={(event) =>
                    setForm((prev) => ({
                      ...prev,
                      tahun_ijazah: event.target.value,
                    }))
                  }
                  className="[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                />
                <InputError
                  text={error?.response?.data.errors?.tahun_ijazah?.join(",")}
                />
              </div>
              {form.jenjang_pendidikan_terakhir_daftar_rpl == "diploma" ? (
                <div>
                  <Label required>Nomor Induk Mahasiswa (NIM) Asal</Label>
                  <Input
                    required
                    value={form.nim || ""}
                    placeholder="Ketik Nomor Induk Mahasiswa (NIM) Asal..."
                    onChange={(event) =>
                      setForm((prev) => ({
                        ...prev,
                        nim: event.target.value,
                      }))
                    }
                  />
                  <InputError
                    text={error?.response?.data?.errors?.nim?.join(",")}
                  />
                </div>
              ) : (
                ""
              )}
              <div>
                <Label required>{t("siswa.layout.register.label.prodi")}</Label>
                <Combobox
                  open={openListProdi}
                  setOpen={setOpenListProdi}
                  value={form.uk_id || ""}
                  setValue={(value) => {
                    setForm((prev) => ({ ...prev, uk_id: value }));
                  }}
                  options={filteredOptionsProdi}
                  placeholder={`${t("siswa.layout.register.label.prodi")}`}
                />
                <InputError
                  text={error?.response?.data.errors?.uk_id?.join(",")}
                />
              </div>
            </>
          ) : (
            <>
              {!selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                "internasional",
              ) ? (
                <div>
                  <Label
                    required={
                      selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug ==
                      "pascasarjana"
                        ? false
                        : true
                    }
                  >
                    NISN
                  </Label>
                  <SegmentedInput
                    type="number"
                    length={10}
                    defaultValue={form.nisn}
                    onComplete={(value: string) => {
                      setForm((prev) => ({
                        ...prev,
                        nisn: value,
                      }));
                    }}
                  />
                  <InputError
                    text={error?.response?.data.errors?.nisn?.join(",")}
                  />
                  <div>
                    <p className="text-muted-foreground">
                      NISN bisa anda lihat melalui link berikut
                    </p>
                    <Link
                      to="https://nisn.data.kemendikdasmen.go.id"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1.5 font-medium text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:underline transition-colors"
                    >
                      Cek NISN disini
                      <ExternalLink className="w-3.5 h-3.5" />
                    </Link>
                  </div>
                </div>
              ) : (
                ""
              )}

              {selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                "pascasarjana",
              ) ||
              selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
                "internasional",
              ) ? (
                <></>
              ) : (
                <>
                  <div>
                    <Label required>Sekolah Asal</Label>
                    <Combobox
                      serverSide
                      open={openListSekolah}
                      setOpen={setOpenListSekolah}
                      value={form.id_ref_sekolah || ""}
                      setValue={(newValue) => {
                        const selected = dataSekolah?.find((option: Option) => {
                          return String(option.value) == String(newValue);
                        });
                        setSelectedSekolah(selected);
                        setForm((prev) => ({
                          ...prev,
                          id_ref_sekolah: newValue,
                          id_ref_jurusan_sekolah: "",
                        }));
                      }}
                      onChange={(event) =>
                        setSearchQuerySekolah(event.target.value)
                      }
                      options={dataSekolah}
                      placeholder="Pilih Sekolah"
                      isPending={isPendingSekolah}
                      searchQueryValue={searchQuerySekolah || ""}
                    />
                    <p className="text-muted-foreground font-semibold">
                      Cari berdasarkan nama sekolah atau NPSN Sekolah!
                    </p>
                    <InputError
                      text={error?.response?.data.errors?.id_ref_sekolah?.join(
                        ",",
                      )}
                    />
                  </div>

                  <div>
                    <Label required>Kurikulum yang digunakan?</Label>
                    <div className="mt-2 flex gap-7">
                      <div className="flex gap-3">
                        <Checkbox
                          required={form.is_kurikulum_merdeka === null}
                          checked={form.is_kurikulum_merdeka === false}
                          onCheckedChange={(checked) => {
                            if (checked) {
                              setForm((prev) => ({
                                ...prev,
                                is_kurikulum_merdeka: false,
                              }));
                            } else {
                              setForm((prev) => ({
                                ...prev,
                                is_kurikulum_merdeka: null,
                              }));
                            }
                          }}
                        />
                        <Label>Kurikulum 2013</Label>
                      </div>
                      <div className="flex gap-3">
                        <Checkbox
                          required={form.is_kurikulum_merdeka === null}
                          checked={form.is_kurikulum_merdeka === true}
                          onCheckedChange={(checked) => {
                            if (checked) {
                              setForm((prev) => ({
                                ...prev,
                                is_kurikulum_merdeka: true,
                              }));
                            } else {
                              setForm((prev) => ({
                                ...prev,
                                is_kurikulum_merdeka: null,
                              }));
                            }
                          }}
                        />
                        <Label>Kurikulum Merdeka</Label>
                      </div>
                      {!isSMK && (
                        <div className="flex gap-3">
                          <Checkbox
                            required={form.is_kurikulum_merdeka === null}
                            checked={form.is_kurikulum_merdeka == 2}
                            onCheckedChange={(checked) => {
                              if (checked) {
                                setForm((prev) => ({
                                  ...prev,
                                  is_kurikulum_merdeka: 2,
                                }));
                              } else {
                                setForm((prev) => ({
                                  ...prev,
                                  is_kurikulum_merdeka: null,
                                }));
                              }
                            }}
                          />
                          <Label>Lainnya</Label>
                        </div>
                      )}
                    </div>
                  </div>
                  {form.is_kurikulum_merdeka !== null &&
                    (isSMK ||
                      (isSMA && form.is_kurikulum_merdeka == false) ||
                      (!isSMA &&
                        !isSMK &&
                        form.is_kurikulum_merdeka == false)) && (
                      <div>
                        <Label required>Jurusan/Program Keahlian Sekolah</Label>
                        <Combobox
                          isPending={isPendingListJurusan}
                          open={openListJurusan}
                          setOpen={setOpenListJurusan}
                          value={form.id_ref_jurusan_sekolah || ""}
                          setValue={(value) => {
                            setForm((prev) => ({
                              ...prev,
                              id_ref_jurusan_sekolah: value,
                            }));
                            setSelectedMapels([]);
                          }}
                          options={filteredListJurusan}
                          placeholder="Pilih jurusan sekolah"
                        />
                        <InputError
                          text={error?.response?.data.errors?.id_ref_jurusan_sekolah?.join(
                            ",",
                          )}
                        />
                      </div>
                    )}

                  {(isSMA && form.is_kurikulum_merdeka) ||
                  (!isSMA && !isSMK && form.is_kurikulum_merdeka) ||
                  (!isSMA && !isSMK && form.is_kurikulum_merdeka === 2) ? (
                    <div>
                      <Label required>
                        Mapel Peminatan Kurikulum Merdeka (Minimal 4, Maksimal
                        5)
                      </Label>
                      <MultiSelect
                        options={listMapelPeminatan || []}
                        onValueChange={(value) => {
                          setSelectedMapels(value);
                          setForm((prev) => ({
                            ...prev,
                            id_ref_jurusan_sekolah: "",
                          }));
                        }}
                        defaultValue={selectedMapels}
                        placeholder="Pilih Mapel Peminatan"
                        variant="inverted"
                        animation={2}
                        maxCount={3}
                      />
                      <InputError
                        text={error?.response?.data.errors?.list_id_ref_mapel_peminatan_kurikulum_merdeka?.join(
                          ",",
                        )}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </>
              )}

              {isPKBM && (
                <div>
                  <Label required>Tanggal Lahir</Label>
                  <Input
                    // required
                    type="date"
                    value={form.tanggal_lahir || ""}
                    onChange={(event) =>
                      setForm((prev) => ({
                        ...prev,
                        tanggal_lahir: event.target.value,
                      }))
                    }
                  />
                  <p className="text-primary font-semibold">
                    {form.tanggal_lahir &&
                      formatDateIndonesia(form.tanggal_lahir, "medium")}
                  </p>
                  <InputError
                    text={error?.response?.data?.errors?.tanggal_lahir?.join(
                      ",",
                    )}
                  />
                </div>
              )}
              <div>
                <Label required>
                  {t("siswa.layout.register.label.tahun-kelulusan")}
                </Label>
                <Input
                  required
                  type="number"
                  maxLength={4}
                  placeholder={`type ${t(
                    "siswa.layout.register.label.tahun-kelulusan",
                  )}...`}
                  value={form.tahun_ijazah}
                  onChange={(event) =>
                    setForm((prev) => ({
                      ...prev,
                      tahun_ijazah: event.target.value,
                    }))
                  }
                  className="[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                />
                <InputError
                  text={error?.response?.data.errors?.tahun_ijazah?.join(",")}
                />
              </div>
            </>
          )}

          {selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
            "pascasarjana",
          ) ||
          selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
            "internasional",
          ) ? (
            <>
              <div>
                <Label>{t("siswa.layout.register.label.jenjang")}</Label>
                <Combobox
                  open={openListJenjang}
                  setOpen={setOpenListJenjang}
                  value={selectedJenjang}
                  setValue={(value) => {
                    setSelectedJenjang(value);
                  }}
                  options={filteredOptionsJenjang}
                  placeholder={`${t("siswa.layout.register.label.jenjang")}`}
                />
              </div>
              <div
                className={`${
                  selectedJenjang ? "" : "opacity-30 pointer-events-none"
                }`}
              >
                <Label>{t("siswa.layout.register.label.prodi")}</Label>
                <Combobox
                  open={openListProdi}
                  setOpen={setOpenListProdi}
                  value={form.uk_id || ""}
                  setValue={(value) => {
                    setForm((prev) => ({ ...prev, uk_id: value }));
                  }}
                  options={filteredOptionsProdi}
                  placeholder={`${t("siswa.layout.register.label.prodi")}`}
                />
              </div>
            </>
          ) : !selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug?.startsWith(
              "profesi",
            ) ? (
            <>
              {/* <div>
                <Label required>Sekolah Asal</Label>
                <Combobox
                  serverSide
                  open={openListSekolah}
                  setOpen={setOpenListSekolah}
                  value={form.id_ref_sekolah || ""}
                  setValue={(newValue) => {
                    const selected = dataSekolah?.find((option: Option) => {
                      return String(option.value) == String(newValue);
                    });
                    setSelectedSekolah(selected);
                    setForm((prev) => ({
                      ...prev,
                      id_ref_sekolah: newValue,
                    }));
                  }}
                  onChange={(event) =>
                    setSearchQuerySekolah(event.target.value)
                  }
                  options={dataSekolah}
                  placeholder="Pilih Sekolah"
                  isPending={isPendingSekolah}
                  searchQueryValue={searchQuerySekolah || ""}
                />
                <InputError
                  text={error?.response?.data.errors?.id_ref_sekolah?.join(",")}
                />
              </div>
              <div>
                <Label required>
                  Apakah saat sekolah belajar menggunakan Kurikulum Merdeka?
                </Label>
                <div className="mt-2 flex gap-7">
                  <div className="flex gap-3">
                    <Checkbox
                      required={form.is_kurikulum_merdeka === null}
                      checked={form.is_kurikulum_merdeka === false}
                      onCheckedChange={(checked) => {
                        if (checked) {
                          setForm((prev) => ({
                            ...prev,
                            is_kurikulum_merdeka: false,
                          }));
                        } else {
                          setForm((prev) => ({
                            ...prev,
                            is_kurikulum_merdeka: null,
                          }));
                        }
                      }}
                    />
                    <Label>Tidak</Label>
                  </div>
                  <div className="flex gap-3">
                    <Checkbox
                      required={form.is_kurikulum_merdeka === null}
                      checked={form.is_kurikulum_merdeka === true}
                      onCheckedChange={(checked) => {
                        if (checked) {
                          setForm((prev) => ({
                            ...prev,
                            is_kurikulum_merdeka: true,
                          }));
                        } else {
                          setForm((prev) => ({
                            ...prev,
                            is_kurikulum_merdeka: null,
                          }));
                        }
                      }}
                    />
                    <Label>Ya</Label>
                  </div>
                </div>
              </div>
              {form.is_kurikulum_merdeka !== null &&
                form.is_kurikulum_merdeka === false && (
                  <div>
                    <Label required>Jurusan Sekolah</Label>
                    <Combobox
                      isPending={isPendingListJurusan}
                      open={openListJurusan}
                      setOpen={setOpenListJurusan}
                      value={form.id_ref_jurusan_sekolah || ""}
                      setValue={(value) => {
                        setForm((prev) => ({
                          ...prev,
                          id_ref_jurusan_sekolah: value,
                        }));
                      }}
                      options={listJurusan}
                      placeholder="Pilih jurusan sekolah"
                    />
                    <InputError
                      text={error?.response?.data.errors?.id_ref_jurusan_sekolah?.join(
                        ","
                      )}
                    />
                  </div>
                )} */}
            </>
          ) : (
            ""
          )}

          <div className="mt-5 flex gap-3">
            <Button
              type="button"
              variant={"outline"}
              onClick={() => {
                setShowPopupJalurMandiri(false);
              }}
            >
              {t("siswa.layout.register.button.batal")}
            </Button>
            <Button variant={"default"}>
              {t("siswa.layout.register.button.daftar")}
            </Button>
          </div>
        </form>
      </Modal>

      <Modal
        className="lg:w-[32rem] w-[90vw]"
        show={showConfirmDaftar}
        onClose={() => {
          setShowConfirmDaftar(false);
          setIsConfirm(false);
        }}
      >
        <FormHeader
          title={`${t("siswa.layout.register.confirmation.title")} ${
            selectedPeriode?.jalur_jenis?.nama_jalur_jenis
          }`}
          icon={<MdWarning />}
        />
        <form onSubmit={handleSubmitPendaftaran}>
          {selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug === "cbt" ||
          selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug ===
            "talentscouting" ||
          selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug === "prestasi" ? (
            <div>
              <Card className="flex-1 overflow-auto">
                <table>
                  <tbody>
                    <tr>
                      <th className="py-1 px-2 text-start whitespace-nowrap">
                        Nama
                      </th>
                      <td className="py-1 px-2">:</td>
                      <td className="py-1 px-2">{form.nama_lengkap}</td>
                    </tr>
                    <tr>
                      <th className="py-1 px-2 text-start whitespace-nowrap">
                        NISN
                      </th>
                      <td className="py-1 px-2">:</td>
                      <td className="py-1 px-2">{form.nisn}</td>
                    </tr>
                    <tr>
                      <th className="py-1 px-2 text-start whitespace-nowrap">
                        Sekolah
                      </th>
                      <td className="py-1 px-2">:</td>
                      <td className="py-1 px-2">{selectedSekolah?.label}</td>
                    </tr>
                    <tr>
                      <th className="py-1 px-2 text-start whitespace-nowrap">
                        Tahun Kelulusan
                      </th>
                      <td className="py-1 px-2">:</td>
                      <td className="py-1 px-2">{form.tahun_ijazah}</td>
                    </tr>
                    {form.is_kurikulum_merdeka && isSMA && (
                      <tr>
                        <th className="py-1 px-2 text-start whitespace-nowrap">
                          Mapel Peminatan
                        </th>
                        <td className="py-1 px-2">:</td>
                        <td className="py-1 px-2">
                          {currentMapels && currentMapels?.length > 0 ? (
                            currentMapels
                              ?.map((option: Option) => option.label)
                              ?.join(", ")
                          ) : (
                            <span className="text-red-500">
                              Mapel Peminatan belum dipilih!
                            </span>
                          )}
                        </td>
                      </tr>
                    )}
                    {(isSMK || !form.is_kurikulum_merdeka) && (
                      <tr>
                        <th className="py-1 px-2 text-start whitespace-nowrap">
                          Jurusan/Program Keahlian Sekolah
                        </th>
                        <td className="py-1 px-2">:</td>
                        <td className="py-1 px-2">
                          {currentJurusan ? (
                            currentJurusan?.label
                          ) : (
                            <span className="text-red-500">
                              Jurusan Sekolah Asal belum dipilih!
                            </span>
                          )}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Card>
              <div className="mt-3 flex items-center gap-3">
                <Checkbox
                  checked={isConfirm}
                  onCheckedChange={(cheked) =>
                    setIsConfirm(cheked ? true : false)
                  }
                />
                <span className={`${isConfirm ? "" : "text-destructive"}`}>
                  Dengan ini saya menyatakan NISN, Nama, Tahun Kelulusan,
                  Sekolah, Jurusan/Program Keahlian Sekolah{" "}
                  <strong>sudah benar</strong>, saya dinyatakan{" "}
                  <strong>TIDAK LULUS</strong> pada jalur SNBP tahun{" "}
                  {selectedPeriode?.tahun}, serta tidak{" "}
                  <strong>MENDAFTAR KEMBALI</strong> pada jalur SNBT tahun{" "}
                  {selectedPeriode?.tahun}.
                </span>
              </div>
            </div>
          ) : selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug === "rpl" ? (
            <div>
              <div className="mt-3 flex items-center gap-3">
                <Checkbox
                  checked={isConfirm}
                  onCheckedChange={(cheked) =>
                    setIsConfirm(cheked ? true : false)
                  }
                />
                <span className={`${isConfirm ? "" : "text-destructive"}`}>
                  DENGAN INI SAYA MENYATAKAN DATA YANG SAYA INPUTKAN SUDAH
                  BENAR.
                </span>
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="mt-5 flex gap-3">
            <Button
              type="button"
              variant={"outline"}
              onClick={() => {
                setShowConfirmDaftar(false);
                setIsConfirm(false);
              }}
              disabled={isPendingStorePendaftaran}
            >
              {t("siswa.layout.register.button.batal")}
            </Button>

            <Button
              className={`flex items-center gap-3 ${
                selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug !=
                  "pascasarjana" &&
                selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug !=
                  "internasional" &&
                selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug !=
                  "profesi" &&
                !isConfirm
                  ? "opacity-50"
                  : ""
              }`}
              disabled={
                isPendingStorePendaftaran ||
                (selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug !=
                  "pascasarjana" &&
                  selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug !=
                    "internasional" &&
                  selectedPeriode?.jalur_jenis?.nama_jalur_jenis_slug !=
                    "profesi" &&
                  !isConfirm)
              }
              variant={"default"}
            >
              {isPendingStorePendaftaran ? (
                <>
                  <Loader2 className="w-4 h-4 mr-1 animate-spin" />
                  Processing...
                </>
              ) : (
                t("siswa.layout.register.confirmation.button")
              )}
            </Button>
          </div>
        </form>
      </Modal>
    </main>
  );
}
